import { css } from "theme/default/css";

export const setFlexDFJCCF1 = css`
  display: flex;
  justify-content: center;
  flex: 1;
`;
